import {createSelector} from 'reselect';

const getShoppingCart = (store) => (store.shoppingCart || {}).shoppingCart || {};
const getPrimeStore = (store) => store.prime;
const getUserStatus = (store) => store.prime.userStatus;

const membershipFeeSelector = createSelector(getShoppingCart, (shoppingCart) => shoppingCart.membershipPerksFee);
const membershipDTOSelector = createSelector(getShoppingCart, (shoppingCart) => shoppingCart.membershipPerksDTO);
const userStatusSelector = createSelector(getUserStatus, (userStatus) => userStatus || '');
const primeMemberSelectedSelector = createSelector(getPrimeStore, (primeStore) => {
    return primeStore.primeMemberSelected || {};
});
const membershipSubscriptionDetailsSelector = createSelector(getPrimeStore, (primeStore) => {
    return primeStore.membershipSubscriptionDetails || {};
});

const primeStatusSelector = createSelector(getShoppingCart, getPrimeStore, (shoppingCart, prime) => {
    const {membershipPerksDTO, membershipPerksFee, primePriceSelected} = shoppingCart;
    const {userStatus, primeMemberSelected, membershipSubscriptionDetails} = prime;
    return {
        primePriceSelected,
        membershipPerksDTO,
        membershipPerksFee,
        userStatus,
        primeMemberSelected,
        membershipSubscriptionDetails,
    };
});

const membershipDiscountSelector = createSelector(getPrimeStore, (primeStore) => primeStore.discount);
const riskyCreditCardSelector = createSelector(getPrimeStore, (primeStore) => {
    const {isRiskyCreditCard} = primeStore;
    return {isRiskyCreditCard};
});

const expiringCreditCardSelector = createSelector(getPrimeStore, ({isExpiringCreditCard}) => {
    return {isExpiringCreditCard};
});

const membershipChurnRiskySelector = createSelector(getPrimeStore, (primeStore) => primeStore.membershipChurnRisky || {});

export default {
    membershipDTO: (store) => membershipDTOSelector(store),
    membershipFee: (store) => membershipFeeSelector(store),
    primeMemberSelected: (store) => primeMemberSelectedSelector(store),
    userStatus: (store) => userStatusSelector(store),
    primeStatus: (store) => primeStatusSelector(store),
    membershipSubscriptionDetails: (store) => membershipSubscriptionDetailsSelector(store),
    membershipDiscount: (store) => membershipDiscountSelector(store),
    isRiskyCreditCard: (store) => riskyCreditCardSelector(store),
    isExpiringCreditCard: (store) => expiringCreditCardSelector(store),
    membershipChurnRisky: (store) => membershipChurnRiskySelector(store),
};
